<template>
  <div>
    <div :class="className" v-if="isShow">
      <validation-observer ref="shipmentRules">
        <!--Container trucking-->
        <div
          v-if="
            ['2', '5'].includes(service_type.toString()) ||
            (['4'].includes(service_type.toString()) &&
              request_quotation.customs_other_service_type == 'CONTAINER')
          "
        >
          <b-row>

            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Customer </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Select Company"
                    @select="
                      ({ text }) => {
                        shipment_on_tms.customer_company_name = text;
                        shipment_on_tms.customer_id = ' ';
                      }
                    "
                    v-model="shipment_on_tms.customer_company_id"
                    :options="companyItems"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Customer Contact </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Select Customer"
                    v-model="shipment_on_tms.customer_id"
                    :options="customer_list_options"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="Phone" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Phone </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.phone"
                    placeholder="Phone"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Contact WR1 </label>
                  <Select2
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.sale_id"
                    :options="sales"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" v-if="false">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label
                    >Accountable Department
                    {{ shipment_on_tms.acc_dept_tms_id }}
                  </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Accountable Department"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.acc_dept_tms_id = tms_id;
                      }
                    "
                    v-model="shipment_on_tms.shipper"
                    :options="acc_dept"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Shipping type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Shipping type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Shipping type"
                    v-model="shipment_on_tms.shipping_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.shipping_type_tms_id = tms_id;
                      }
                    "
                    :options="
                      service_type == 5
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : service_type == 6
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : transport_types.filter((i) => [1, 2].includes(i.id))
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Commodity </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Commodity"
                    v-model="shipment_on_tms.goods_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.goods_type_tms_id = tms_id;
                      }
                    "
                    :options="goods_types"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                name="Amount Truck"
                #default="{ errors }"
                rules="max_value:100"
              >
                <b-form-group>
                  <label>Amount Truck </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.amount_truck"
                    placeholder="Amount Truck"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                name="Container Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Container Type </label>

                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.cont_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.cont_type_tms_id = tms_id;
                      }
                    "
                    :options="
                      cont_types.filter((i) => i.group === 'Container truck')
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                name="Gross Weight"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Gross Weight </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.trong_luong"
                    placeholder="Gross Weight"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Pick up date"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Pick up date <font class="red">*</font> </label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="shipment_on_tms.from_date"
                      type="datetime"
                      class="w-full"
                      :disabled="readonlyFrom"
                      value-type="format"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Delivery date"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Delivery date <font class="red">*</font></label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="shipment_on_tms.to_date"
                      :disabled-date="disabledRangeDelivery"
                      type="datetime"
                      :disabled="readonlyFrom"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="w-full"
                      value-type="format"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="6">
              <validation-provider
                name="Delivery date"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Delivery date 123 </label>
                  <section>
                     <date-picker  ref="datePicker"
                      v-model="shipment_on_tms.to_date"
                      :disabled-date="disabledRangeDelivery"
                      type="datetime"
                      class="w-full"
                      :disabled="readonlyFrom"
                      value-type="format"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                   
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col> -->
            <b-col cols="6">
              <validation-provider name="Pickup" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Pickup </label>

                  <Select4
                    v-model="shipment_on_tms.pickup_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Pick up "
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.pickup_location_tms_id = tms_id;
                      }
                    "
                    :disabled="readonlyFrom"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Delivery </label>

                  <Select4
                    v-model="shipment_on_tms.delivery_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Delivery "
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.delivery_location_tms_id = tms_id;
                      }
                    "
                    :disabled="readonlyFrom"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Empty Depot"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Empty Depot </label>

                  <Select4
                    v-model="shipment_on_tms.deport"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Empty Depot"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.depot_tms_id = tms_id;
                      }
                    "
                    :disabled="readonlyFrom"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <!-- <b-form-group>
                  <label>Cut off time </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.cut_off"
                    placeholder="Cut off time"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group> -->
              <b-form-group>
                <label>Cut-off</label>

                <section>
                  <date-picker
                    ref="datePicker"
                    v-model="shipment_on_tms.cut_off"
                    type="datetime"
                    :disabled="readonlyFrom"
                    class="w-full"
                    value-type="format"
                    title-format="DD-MM-YYYY"
                    time-title-format="DD-MM-YYYY"
                    placeholder="Select datetime"
                    :show-time-panel="showTimePanel"
                    format="DD-MM-YYYY HH:mm"
                    @close="handleOpenChange"
                  >
                    <template v-slot:footer>
                      <button
                        class="mx-btn mx-btn-text"
                        @click="toggleTimePanel"
                      >
                        {{ showTimePanel ? "Date" : "Time" }}</button
                      >Carrier
                    </template>
                  </date-picker>
                </section>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Carrier </label>

                  <Select4
                    v-model="shipment_on_tms.shipping_line"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.shipping_line_tms_id = tms_id;
                      }
                    "
                    placeholder="Carrier"
                    :disabled="readonlyFrom"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: shipping_lines,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Shipping Line' },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="BK/HBL/INV"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>BK/HBL/INV </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.bk_hbl_inv"
                    placeholder="BK/HBL/INV"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Contact pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Contact pick up</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.contact_pickup"
                    placeholder="Contact pick up"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Contact delivery "
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Contact delivery </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.contact_delivery"
                    placeholder="Contact delivery"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Container No."
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Container No.</label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.container_no"
                    placeholder="Container No."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Seal No"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Seal No </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.seal_no"
                    placeholder="Seal No"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Note 1</label>
                  <b-form-textarea
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    rows="6"
                    v-model="shipment_on_tms.note1"
                    placeholder="Note 1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Note 2 (Billing information)</label>
                  <b-form-textarea
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    rows="6"
                    v-model="shipment_on_tms.note2"
                    placeholder="Note 2 (Billing information)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1" v-if="!readonlyFrom">
              <a
                @click="sendNewShipmentToTMS"
                class="btn round btn-primary pl-3 pr-3"
                ><feather-icon icon="SendIcon" /> Send To TMS</a
              >
            </b-col>
          </b-row>
        </div>
        <!-- Form Van trucking -->
        <div
          v-if="
            ['1', '3', '6'].includes(service_type.toString()) ||
            (['4'].includes(service_type.toString()) &&
              request_quotation.customs_other_service_type == 'VAN')
          "
        >
          <b-row>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Customer </label>

                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Select Company"
                    @select="
                      ({ text }) => {
                        shipment_on_tms.customer_company_name = text;
                        shipment_on_tms.customer_id = ' ';
                      }
                    "
                    v-model="shipment_on_tms.customer_company_id"
                    :options="companyItems"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Customer Contact </label>
                  <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.customer_name"
                    placeholder="Customer Contact"
                  /> -->
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Select Customer"
                    v-model="shipment_on_tms.customer_id"
                    :options="customer_list_options"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="Phone" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Phone </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.phone"
                    placeholder="Phone"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Contact WR1"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Contact WR1 </label>

                  <Select2
                    v-model="shipment_on_tms.sale_id"
                    :options="sales"
                    :disabled="readonlyFrom"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" v-if="false">
              <validation-provider
                name="Accountable Department"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Accountable Department </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.acc_dept_tms_id = tms_id;
                      }
                    "
                    placeholder="Accountable Department"
                    v-model="shipment_on_tms.shipper"
                    :options="acc_dept"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Shipping type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Shipping type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Shipping type"
                    v-model="shipment_on_tms.shipping_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.shipping_type_tms_id = tms_id;
                      }
                    "
                    :options="
                      service_type == 5 ||
                      (service_type == 4 &&
                        shipment_on_tms.customs_other_service_type ==
                          'CONTAINER') ||
                      service_type == 6 ||
                      (service_type == 4 &&
                        shipment_on_tms.customs_other_service_type == 'VAN')
                        ? transport_types.filter((i) =>
                            [1, 2, 3, 4].includes(i.id)
                          )
                        : transport_types.filter((i) => [1, 2].includes(i.id))
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="BK/HBL/INV"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>BK/HBL/INV </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.bk_hbl_inv"
                    placeholder="BK/HBL/INV"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Amount Truck"
                #default="{ errors }"
                rules="max_value:100"
              >
                <b-form-group>
                  <label>Amount Truck </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.amount_truck"
                    placeholder="Amount Truck"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="6">
              <validation-provider
                :name="
                  ['4'].includes(service_type) &&
                  shipment_on_tms.customs_other_service_type != 'VAN'
                    ? 'Container Type'
                    : ' Truck type'
                "
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label
                    >{{
                      ["4"].includes(service_type) &&
                      shipment_on_tms.customs_other_service_type != "VAN"
                        ? "Container Type"
                        : " Truck type"
                    }}
                  </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    :placeholder="
                      ['4'].includes(service_type) &&
                      shipment_on_tms.customs_other_service_type != 'VAN'
                        ? 'Container Type'
                        : ' Truck type'
                    "
                    v-model="shipment_on_tms.truck_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.customs_other_service_type != 'VAN' ?   shipment_on_tms.truck_type_tms_id = tms_id : shipment_on_tms.truck_type_tms_id = tms_id   ;
                      }
                    "
                    :options="
                      ['4'].includes(service_type) &&
                      shipment_on_tms.customs_other_service_type != 'VAN'
                        ? cont_types.filter(
                            (i) => i.group === 'Container truck'
                          )
                        : cont_types.filter((i) => i.group === 'van truck')
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col> -->

            <b-col
              cols="12"
              lg="6"
              v-if="
                ['4'].includes(service_type) &&
                shipment_on_tms.customs_other_service_type != 'VAN'
              "
            >
              <validation-provider
                name="Container Type"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Container Type <font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Container Type"
                    v-model="shipment_on_tms.cont_type"
                    :options="
                      cont_types.filter((i) => i.group === 'Container truck')
                    "
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.cont_type_tms_id = tms_id;
                      }
                    "
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" lg="6" v-else>
              <validation-provider
                name="Truck Type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Truck Type</label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Truck Type"
                    v-model="shipment_on_tms.truck_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.truck_type_tms_id = tms_id;
                      }
                    "
                    :options="cont_types.filter((i) => i.group === 'van truck')"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Pick up date"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Pick up date <font class="red">*</font></label>
                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="shipment_on_tms.from_date"
                      type="datetime"
                      :disabled="readonlyFrom"
                      class="w-full"
                      value-type="format"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Delivery date"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Delivery date <font class="red">*</font></label>
                  <!-- <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.from_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  /> -->
                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="shipment_on_tms.to_date"
                      :disabled-date="disabledRangeDelivery"
                      type="datetime"
                      :disabled="readonlyFrom"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      class="w-full"
                      value-type="format"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Pickup {{ shipment_on_tms.pickup_location }}</label>

                  <Select4
                    v-model="shipment_on_tms.pickup_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Pickup"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.pickup_location_tms_id = tms_id;
                      }
                    "
                    :disabled="readonlyFrom"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Delivery</label>

                  <Select4
                    v-model="shipment_on_tms.delivery_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Delivery"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.delivery_location_tms_id = tms_id;
                      }
                    "
                    :disabled="readonlyFrom"
                    :options="{
                      isSearch: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Contact pick up"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Contact pick up </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.contact_pickup"
                    placeholder="Contact pick up"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Contact delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Contact delivery </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.contact_delivery"
                    placeholder="Contact delivery"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider
                name="Package type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Package type </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Package type"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.package_type"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.package_type_tms_id = tms_id;
                      }
                    "
                    :options="cont_types.filter((i) => i.group === 'packaging')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Commodity"
                    @select="
                      ({ tms_id }) => {
                        shipment_on_tms.goods_type_tms_id = tms_id;
                      }
                    "
                    v-model="shipment_on_tms.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Quantity Package"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Quantity Package </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.so_luong"
                    placeholder="Quantity Package"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Gross Weight "
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Gross Weight </label>
                  <b-form-input
                    :disabled="readonlyFrom"
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.trong_luong"
                    placeholder="Gross Weight"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Volume (CBM)"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Volume (CBM) </label>
                  <b-form-input
                    :disabled="readonlyFrom"
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.so_khoi"
                    placeholder="Volume (CBM)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Note 1</label>
                  <b-form-textarea
                    :disabled="readonlyFrom"
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.note1"
                    placeholder="Note 1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Note 2 (Billing information)</label>
                  <b-form-textarea
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.note2"
                    placeholder="Note 2 (Billing information)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1" v-if="!readonlyFrom">
              <a
                @click="sendNewShipmentToTMS"
                class="btn round btn-primary pl-3 pr-3"
                ><feather-icon icon="SendIcon" /> Send To TMS</a
              >
            </b-col>
          </b-row>
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<style>
.red {
  color: red;
}

.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}
</style>
<script>
import {
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";

import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { checkDateToFormatDynamic } from "@/utils/format";

import { $ctx } from "@themeConfig";

export default {
  props: {
    cards: {},
    className: { default: "booking-online" },
    readonly: { default: false, type: Boolean },
    request_quotation: { default: null },
    booking: { default: null },
  },
  components: {
    BButton,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
  },
  data() {
    return {
      cut_off: "",
      customer_list_options: null,
      isShow: false,
      showTimePanel: false,
      showTimeRangePanel: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        addRemoveLinks: true,
        createImageThumbnails: false,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      service_type: null,
      service_type: null,
      fast_services: [
        { id: "1", text: "Import (Air)", service_type: 1 },
        { id: "2", text: "Export (Air)", service_type: 1 },
        { id: "3", text: "Import (Consol)", service_type: 2 },
        { id: "4", text: "Export (Consol)", service_type: 2 },
        { id: "5", text: "Import (Sea FCL)", service_type: 3 },
        { id: "6", text: "Export (sea FCL)", service_type: 3 },
        { id: "7", text: "Logistics", service_type: 4 },
        { id: "8", text: "Inland Trucking", service_type: 5 },
        { id: "9", text: "Inland Trucking", service_type: 6 },
      ],
      shipment_on_tms: {
        customer_name: null,
        sale_id: null,
        customer_id: null,
        shipper: null,
        cut_off: null,
      },
      shipment_detail: {},
    };
  },
  watch: {
    cut_off(n) {
      this.shipment_on_tms.cut_off = n;
    },
  },
  computed: {
    ...mapState("masterData", [
      "locations",
      "service_types",
      "cont_types",
      "goods_types",
      "regions",
      "ports",
      "transport_types",
      "deports",
      "acc_dept",
      "shipping_lines",
      "sales",
      "companyItems",
    ]),
  },
  async mounted() {
    this.readonlyFrom = this.readonly;
    this.$loading.show();

    this.service_type = this.request_quotation?.service_type || "";
    this.shipment_on_tms.id = this.request_quotation.id;
    this.shipment_on_tms.customs_other_service_type =
      this.request_quotation.customs_other_service_type || null;
    var vm = this;
    useJwt
      .get("wr1?objectType=GetBookingDetail", {
        params: { search: { id: this.request_quotation.id } },
      })
      .then((response) => {
        if (response.data.result.shipment_detail != null) {
          vm.shipment_detail = JSON.parse(response.data.result.shipment_detail);
        }
        if (response.data.result.shipment_on_tms_info != null) {
          this.shipment_on_tms = JSON.parse(
            response.data.result.shipment_on_tms_info
          );
          this.shipment_on_tms.customer_company_id =
            this.request_quotation.company_id;
          this.shipment_on_tms.customer_company_name =
            this.request_quotation.customer_company_name;
          this.shipment_on_tms.phone = this.request_quotation.customer_phone;

          this.readonlyFrom = true;
          this.$nextTick(() => {
            this.isShow = true;
          });
        } else {
          this.shipment_on_tms.pricing = this.booking;
          this.shipment_on_tms.customer_name =
            response.data.result.customer_name;

          this.shipment_on_tms.phone = this.request_quotation.customer_phone;
          this.shipment_on_tms.sale_id = this.request_quotation.sale_id;
          this.shipment_on_tms.customer_id = response.data.result.customer_id;
          this.shipment_on_tms.customer_company_name =
            this.request_quotation.customer_company_name;
          this.shipment_on_tms.customer_company_id =
            this.request_quotation.company_id;
          this.request_quotation.customer_company_name;
          this.readonlyFrom = false;
          this.shipment_on_tms.sale_name = this.request_quotation.sale_name;
          this.loadDefaultInfo();
        }

        this.getListKH();

        this.isShow = true;
      });

    this.$loading.hide();
  },
  methods: {
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    getListKH() {
      useJwt
        .get("wr1?objectType=CustomerListCompany", {
          params: { search: this.shipment_on_tms.customer_company_id },
        })
        .then((response) => {
          this.customer_list_options = this.formatOption(response.data.result);
        });
    },
    disabledRangeDelivery: function (date) {
      if (this.request_quotation.pick_up_date) {
        var mydate = moment(this.request_quotation.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    loadDefaultInfo() {
      this.shipment_on_tms.etd = this.request_quotation.from_date;
      this.shipment_on_tms.goods_type = this.request_quotation.goods_type;

      this.shipment_on_tms.goods_type_tms_id =
        this.goods_types.find((e) => e.id == this.shipment_on_tms.goods_type)
          ?.tms_id || "";

      this.shipment_on_tms.mo_ta = this.request_quotation.mo_ta;

      this.shipment_on_tms.package_type_tms_id =
        this.cont_types.find((e) => e.id == this.request_quotation.package_type)
          ?.tms_id || "";

      this.shipment_on_tms.pol_port = this.request_quotation.pol_port;
      this.shipment_on_tms.pod_port = this.request_quotation.pod_port;

      this.shipment_on_tms.truck_type = this.request_quotation.truck_type;
      this.shipment_on_tms.so_luong = this.request_quotation.so_luong;
      this.shipment_on_tms.cont_type = this.request_quotation.cont_type;

      this.shipment_on_tms.from_date = checkDateToFormatDynamic(
        (this.shipment_detail.inland_pick_up_date ||
          this.request_quotation.inland_pick_up_date) +
          " " +
          (this.shipment_detail.inland_pick_up_time ||
            this.request_quotation.inland_pick_up_time),
        "DD-MM-YYYY HH:mm"
      );
      this.shipment_on_tms.to_date = checkDateToFormatDynamic(
        (this.shipment_detail.inland_delivery_date ||
          this.request_quotation.inland_delivery_date) +
          " " +
          (this.shipment_detail.inland_pick_up_time ||
            this.request_quotation.inland_pick_up_time),
        "DD-MM-YYYY HH:mm"
      );
      this.shipment_on_tms.cont_type = this.request_quotation.cont_type;
      this.shipment_on_tms.note1 = this.request_quotation.notes;
      this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
        this.request_quotation.cutOffDate,
        "DD-MM-YYYY HH:mm"
      );

      this.shipment_on_tms.shipping_type =
        this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].package_type; // long fix
      this.shipment_on_tms.amount_truck = this.request_quotation.so_luong;
      this.shipment_on_tms.contact_pickup = this.request_quotation.PICPickUp;
      this.shipment_on_tms.contact_delivery =
        this.request_quotation.PICDelivery;

      this.shipment_on_tms.pickup_location =
        this.request_quotation.pickup_location;
      this.shipment_on_tms.delivery_location =
        this.request_quotation.delivery_location;
      if (this.request_quotation.service_type == "5") {
        //Container Trucking

        if (this.shipment_detail.valueContainer) {
          this.shipment_on_tms.trong_luong =
            this.shipment_detail?.valueContainer?.[0].ContainerLine?.[0].total_gross_weight;
          this.shipment_on_tms.cont_type =
            this.shipment_detail?.valueContainer?.[0].ContainerLine?.[0].total_gross_weight;
          if (
            this.shipment_detail.pickUpDate &&
            this.shipment_detail.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.shipment_detail.pickUpDate +
                " " +
                this.shipment_detail.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.shipment_detail.deliveryDate &&
            this.shipment_detail.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.shipment_detail.deliveryDate +
                " " +
                this.shipment_detail.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.note1 = this.shipment_detail.notes_truck;
          this.shipment_on_tms.amount_truck =
            this.shipment_detail?.valueContainer?.[0].ContainerLine?.[0]?.quantity;
          if (
            this.shipment_details?.pickUpContact?.name &&
            this.shipment_details?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.shipment_details?.pickUpContact?.name +
              " " +
              this.shipment_details?.pickUpContact?.phone;
          }
          if (
            this.shipment_details?.deliveryContact?.name &&
            this.shipment_details?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.shipment_details?.deliveryContact?.name +
              " " +
              this.shipment_details?.deliveryContact?.phone;
          }
        } else {
          this.shipment_on_tms.trong_luong =
            this.request_quotation?.valueContainer?.[0].ContainerLine?.[0].total_gross_weight;
          this.shipment_on_tms.cont_type =
            this.request_quotation?.valueContainer?.[0].ContainerLine?.[0].cont_type;

          if (
            this.request_quotation.pickUpDate &&
            this.request_quotation.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.request_quotation.pickUpDate +
                " " +
                this.request_quotation.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }
          //deliveryDate
          if (
            this.request_quotation.deliveryDate &&
            this.request_quotation.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.request_quotation.deliveryDate +
                " " +
                this.request_quotation.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          // notes_truck
          this.shipment_on_tms.note1 = this.request_quotation.notes_truck;
          this.shipment_on_tms.goods_type =
            this.shipment_detail?.valueContainer?.[0]?.commodity_type ||
            this.request_quotation?.valueContainer?.[0]?.commodity_type;
          //Cut-off
          if (
            this.shipment_detail.cargo_closing_date &&
            this.shipment_detail.cargo_closing_time
          ) {
            this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
              this.shipment_detail.cargo_closing_date +
                " " +
                this.shipment_detail.cargo_closing_time,
              "DD-MM-YYYY HH:mm"
            );
          } else {
            this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
              this.request_quotation.cargo_closing_date +
                " " +
                this.request_quotation.cargo_closing_time,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.shipping_type =
            this.request_quotation.shippingType;

          //quantity
          this.shipment_on_tms.amount_truck =
            this.request_quotation?.valueContainer?.[0].ContainerLine?.[0].quantity;

          if (
            this.request_quotation?.pickUpContact?.name &&
            this.request_quotation?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.pickUpContact?.name +
              " " +
              this.request_quotation?.pickUpContact?.phone;
          }

          //contact_delivery
          if (
            this.request_quotation?.deliveryContact?.name &&
            this.request_quotation?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.deliveryContact?.name +
              " " +
              this.request_quotation?.deliveryContact?.phone;
          }

          // long fix
        }
      } else if (this.request_quotation.service_type == "3") {
        if (this.shipment_detail.showAddMore) {
          this.shipment_on_tms.trong_luong =
            this.shipment_detail?.showAddMore?.[0].showAddMoreLine?.[0].gross_weight; // long fix
          this.shipment_on_tms.so_khoi =
            this.shipment_detail?.showAddMore?.[0].showAddMoreLine?.[0].volume; // long fix
          this.shipment_on_tms.package_type =
            this.shipment_detail?.showAddMore?.[0].showAddMoreLine?.[0].package_type;
          this.shipment_on_tms.so_luong =
            this.shipment_detail?.showAddMore?.[0].showAddMoreLine?.[0]?.packages;

          this.shipment_on_tms.pickup_location =
            this.shipment_detail.pickup_location;
          this.shipment_on_tms.delivery_location =
            this.shipment_detail.delivery_location;

          if (
            this.shipment_detail.pickUpDate &&
            this.shipment_detail.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.shipment_detail.pickUpDate +
                " " +
                this.shipment_detail.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.shipment_detail.deliveryDate &&
            this.shipment_detail.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.shipment_detail.deliveryDate +
                " " +
                this.shipment_detail.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }
        } else {
          this.shipment_on_tms.trong_luong =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].gross_weight; // long fix
          this.shipment_on_tms.so_khoi =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].volume; // long fix
          this.shipment_on_tms.package_type =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].package_type;
          this.shipment_on_tms.so_luong =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0]?.packages;

          this.shipment_on_tms.pickup_location =
            this.request_quotation.pickup_location;
          this.shipment_on_tms.delivery_location =
            this.request_quotation.delivery_location;
          // inland_contact_pick_up.name
          //inland_contact_delivery

          if (
            this.request_quotation?.door_contact_pick_up?.name &&
            this.request_quotation?.door_contact_pick_up?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.door_contact_pick_up?.name +
              " " +
              this.request_quotation?.door_contact_pick_up?.phone;
          }

          if (
            this.request_quotation?.door_contact_delivery?.name &&
            this.request_quotation?.door_contact_delivery?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.door_contact_delivery?.name +
              " " +
              this.request_quotation?.door_contact_delivery?.phone;
          }

          if (
            this.request_quotation?.inland_contact_pick_up?.name &&
            this.request_quotation?.inland_contact_pick_up?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.inland_contact_pick_up?.name +
              " " +
              this.request_quotation?.inland_contact_pick_up?.phone;
          }

          if (
            this.request_quotation?.inland_contact_delivery?.name &&
            this.request_quotation?.inland_contact_delivery?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.inland_contact_delivery?.name +
              " " +
              this.request_quotation?.inland_contact_delivery?.phone;
          }
        }
      } else if (this.request_quotation.service_type == "6") {
        // VAN
        if (this.shipment_detail.valueVan) {
          this.shipment_on_tms.trong_luong =
            this.shipment_detail?.valueVan?.[0].VanLine?.[0].total_gross_weight; // long fix
          this.shipment_on_tms.so_khoi =
            this.shipment_detail?.valueVan?.[0].VanLine?.[0].total_volume; // long fix
          this.shipment_on_tms.so_luong =
            this.shipment_detail?.valueVan?.[0].VanLine?.[0].total_package;
          this.shipment_on_tms.mo_ta =
            this.shipment_detail?.valueVan?.[0].VanLine?.[0].commodity;
          this.shipment_on_tms.goods_type =
            this.shipment_detail?.valueVan?.[0].VanLine?.[0].commodity_type;
          this.shipment_on_tms.truck_type =
            this.shipment_detail?.valueVan?.[0].truck_type;
          this.shipment_on_tms.shipping_type =
            this.shipment_detail.shippingType;

          //quantity
          this.shipment_on_tms.amount_truck =
            this.shipment_detail?.valueVan?.[0].quantity;

          if (
            this.shipment_detail.pickUpDate &&
            this.shipment_detail.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.shipment_detail.pickUpDate +
                " " +
                this.shipment_detail.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.shipment_detail.deliveryDate &&
            this.shipment_detail.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.shipment_detail.deliveryDate +
                " " +
                this.shipment_detail.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          this.shipment_on_tms.note1 = this.shipment_detail.notes_truck;
          if (
            this.shipment_details?.pickUpContact?.name &&
            this.shipment_details?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.shipment_details?.pickUpContact?.name +
              " " +
              this.shipment_details?.pickUpContact?.phone;
          }
          if (
            this.shipment_details?.deliveryContact?.name &&
            this.shipment_details?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.shipment_details?.deliveryContact?.name +
              " " +
              this.shipment_details?.deliveryContact?.phone;
          }
        } else {
          this.shipment_on_tms.trong_luong =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].total_gross_weight; // long fix
          this.shipment_on_tms.so_khoi =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].total_volume; // long fix
          this.shipment_on_tms.so_luong =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].total_package;
          this.shipment_on_tms.mo_ta =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].commodity;
          this.shipment_on_tms.goods_type =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].commodity_type;
          this.shipment_on_tms.truck_type =
            this.request_quotation?.valueVan?.[0].truck_type;
          this.shipment_on_tms.shipping_type =
            this.request_quotation.shippingType;

          //quantity
          this.shipment_on_tms.amount_truck =
            this.request_quotation?.valueVan?.[0].quantity;

          if (
            this.request_quotation.pickUpDate &&
            this.request_quotation.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.request_quotation.pickUpDate +
                " " +
                this.request_quotation.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.request_quotation.deliveryDate &&
            this.request_quotation.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.request_quotation.deliveryDate +
                " " +
                this.request_quotation.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.note1 = this.request_quotation.notes_truck;

          if (
            this.request_quotation?.pickUpContact?.name &&
            this.request_quotation?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.pickUpContact?.name +
              " " +
              this.request_quotation?.pickUpContact?.phone;
          }
          if (
            this.request_quotation?.deliveryContact?.name &&
            this.request_quotation?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.deliveryContact?.name +
              " " +
              this.request_quotation?.deliveryContact?.phone;
          }
        }
      }

      this.shipment_on_tms.cont_type_tms_id =
        this.cont_types.find((e) => e.id == this.request_quotation.cont_type)
          ?.tms_id || "";

      this.shipment_on_tms.truck_type_tms_id =
        this.cont_types.find((e) => e.id == this.request_quotation.truck_type)
          ?.tms_id || "";
      // shipment_on_tms.truck_type_tms_id = tms_id

      this.shipment_on_tms.shipper =
        this.service_type == 5 ||
        this.request_quotation.has_container_trucking ||
        this.request_quotation.customs_other_service_type == "CONTAINER"
          ? 4
          : this.service_type == 6 ||
            this.request_quotation.has_van_trucking ||
            this.request_quotation.customs_other_service_type == "VAN"
          ? 5
          : null;

      this.shipment_on_tms.acc_dept_tms_id =
        this.acc_dept.find((e) => e.id == this.shipment_on_tms.shipper)
          ?.tms_id || "";

      this.shipment_on_tms.pickup_location_tms_id =
        this.locations.find((e) => e.id == this.shipment_on_tms.pickup_location)
          ?.tms_id || "";

      this.shipment_on_tms.delivery_location_tms_id =
        this.locations.find(
          (e) => e.id == this.shipment_on_tms.delivery_location
        )?.tms_id || "";

      this.shipment_on_tms.bk_hbl_inv = this.request_quotation.cargo_booking;
      this.shipment_on_tms.deport =
        this.request_quotation.deport || this.request_quotation.deport_location;

      this.shipment_on_tms.depot_tms_id =
        this.locations.filter(
          (e) =>
            e.id == this.request_quotation.deport ||
            e.id == this.request_quotation.deport_location
        )[0]?.tms_id || "";

      this.shipment_on_tms.shipping_line = this.request_quotation.shipping_line;
      this.shipment_on_tms.shipping_line_tms_id =
        this.shipping_lines.filter(
          (e) => e.id == this.request_quotation.shipping_line
        )[0]?.tms_id || "";
      this.shipment_on_tms.container_no = this.request_quotation.container_no;
      this.shipment_on_tms.seal_no = this.request_quotation.seal_no;

      this.shipment_on_tms.note2 = this.request_quotation.billingInformation;

      this.shipment_on_tms.shipping_type_tms_id =
        this.transport_types.filter(
          (i) => i.id == this.request_quotation.shippingType
        )[0]?.tms_id || "";
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    async sendNewShipmentToTMS() {
      if (
        this.shipment_on_tms.acc_dept_tms_id == undefined ||
        this.shipment_on_tms.acc_dept_tms_id == null
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              "Accountable Department is invalid value, please check again!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      var validate = await this.$refs.shipmentRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      this.$loading.show();
      useJwt
        .put("wr1?objectType=NewShipmentToTMS", this.shipment_on_tms)
        .then((response) => {
          if (response.data.code == 200) {
            this.$emit("NewShipmentToTMS", response.data.meta?.status || 0);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Shipment to TMS success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Send Shipment to TMS error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },
};
</script>
